import { HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { from } from 'rxjs';
import { Client } from 'src/app/models/client.model';
import { ErpService } from 'src/app/services/net/erp.service';
import { ConnectionManagerService } from 'src/app/services/storage/connection-manager.service';

@Component({
  selector: 'app-limit-create',
  templateUrl: './limit-create.component.html',
  styleUrl: './limit-create.component.scss'
})
export class LimitCreateComponent implements OnInit {
  save() {
    if (!this.query || !this.buypoint) {
      return
    }

    this.loading = true
    this.erp.createLimitQueriy(this.query).subscribe({
      next: () => {
        this.loading = false

        if (this.buypoint) {


          if (this.buypoint?.isOwn) {
            this.router.navigate(["/ors", this.buypoint.id])
          } else {
            this.router.navigate(["/client", this.buypoint.id])
          }
        }
        else {
          this.router.navigate(["/clients"])
        }

      },
      error: (err) => {

        this.loading = false
        console.error(err)
        this.snack.open(`Не удалось сохранить запрос`, 'Закрыть', { duration: 5000 })
        return

      }

    })

  }

  buypoint: Client | undefined
  query: Query = {} as Query
  id: string | undefined;
  loading = false

  /**
   *
   */
  constructor(
    private route: ActivatedRoute,
    public cm: ConnectionManagerService,
    private router: Router,
    private snack: MatSnackBar,
    private erp: ErpService


  ) {


  }


  ngOnInit(): void {

    this.route.paramMap.subscribe((params) => {
      this.id = params.get('id') as string
      this.getClientDb()


    })

  }
  getClientDb() {
    this.loading = true

    from(this.cm.getDb()).subscribe((db) => {
      if (!this.id || !db) return



      db.getClient(this.id).subscribe(bp => {
        this.buypoint = bp
        this.loading = false

        if (!this.buypoint) {
          return
        }
        this.query = {
          BuypointCode: this.buypoint.code,
          Images: [],
          LimitBuypoint: 0,
          LimitClient: 0,
          Note: "", //RPA Market - ТЕСТ. Просьба отклонить данный запрос. 
          Type: 'Снятие стопа',
          SubType: 'По ТТ'

        }


      })
    })


  }


  uploadFile(event: Event) {

    const file = (event.target as HTMLInputElement).files?.item(0)

    if (!file) {
      this.snack.open(`Не удалось загрузить файл - (не удалось взять файл из event)`, 'Закрыть', { duration: 5000 })
      return
    }

    this.loading = false

    this.erp.uploadFile(file, "limitQuery", this.buypoint?.id ?? "no_buypoint_id").subscribe(
      {
        next: (val: any) => {

          switch (val.type) {
            case HttpEventType.Response: {
              this.loading = false
              // console.log(val)
              if (this.query) {
                this.query.Images.push(val.body.url)
              }
            }
          }
        },
        error: (err) => {
          this.loading = false
          console.error(err)
          this.snack.open(`Не удалось загрузить файл`, 'Закрыть', { duration: 5000 })
          return

        }
      }
    )

  }
}


interface Query {
  BuypointCode: string | undefined,
  LimitClient: number,
  LimitBuypoint: number,
  Note: string | undefined
  Images: string[]
  Type: "Снятие стопа" | "Увеличение лимита"
  SubType: "По ТТ" | "По клиенту"


}